"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressesByChainId = exports.addresses = void 0;
exports.addresses = {
    prod: {
        // mainnet
        1: {
            multisig: "0x9d9C46aCa6a2c5FF6824A92d521b6381f9f8F1a9",
            proxyAdminAddress: "0x72DE36c8ebEAcB6100C36249552e35fefF0EE099",
            treasury: "0x67Df244584b67E8C51B10aD610aAfFa9a402FdB6",
            nft721: "0x3B3ee1931Dc30C1957379FAc9aba94D1C48a5405",
            nftMarket: "0xcDA72070E455bb31C7690a170224Ce43623d0B6f",
            percentSplit: "0x00Fc4bB5349F1104D3252c36C308688651e3eb1F",
            proxy: "0x461AA494426e04fB2449068BaD5948a0d720aEf2",
            nftCollectionFactoryV1: "0x3B612a5B49e025a6e4bA4eE4FB1EF46D13588059",
            feth: "0x49128CF8ABE9071ee24540a296b5DED3F9D50443",
            middleware: "0xC0032194d7B298465D558ab1B91Ab2ca6991959C",
            nftDropMarket: "0x53F451165Ba6fdbe39A134673d13948261B2334A",
            nftCollectionFactoryV2: "0x612E2DadDc89d91409e40f946f9f7CfE422e777E",
            nftMarketRouter: "0x762340B8a40Cdd5BFC3eDD94265899FDa345D0E3",
            worlds: "0x69525Dac489e4718964B5615c3D794a25d62bEb7",
            highlight: {
                mintManager: "0x1bf979282181f2b7a640d17aB5D2e25125F2de5e",
                discreteDutchAuctionMechanic: "0x94fa6e7fc2555ada63ea56cfff425558360f0074",
            },
            multiTokenDropMarket: "0xf7e3609a5615a34b8755ee62421b9aDDEA7670B1",
        },
        // base
        8453: {
            multisig: "0xB8CECd6780D93317A149Ad01445936e2C388d040",
            proxyAdminAddress: "0xc8F9867c640BDed3355c54A939F022e6eA8633B3",
            treasury: "0x28562798b92d5A0127989a3AAC70FdCf1e6d4f9E",
            nftMarket: "0x7b503e206dB34148aD77e00afE214034EDF9E3fF",
            percentSplit: "0xB7468D32eE9b2CA97bCAE42d5a9e44CA671dD5B8",
            feth: "0xa5ffFcf1C80435cCAe759891B6D122B4EFaFa810",
            middleware: "0xa293A741fDC980813fa6e32C047e79dbB3D11530",
            nftDropMarket: "0x62037b26ffF91929655AA3A060F327b47d1e2b3e",
            nftCollectionFactoryV2: "0xf1814213A5Ef856aAa1fdb0F7f375569168d8E73",
            nftMarketRouter: "0xFee588791CdA1D01CCFc80b51eFa00C0BE5B129e",
            worlds: "0xc65A34319d4856F6C9C8BA4b07464F24aE252b4a",
            multiTokenDropMarket: "0x132363a3bbf47E06CF642dd18E9173E364546C99",
        },
    },
    staging: {
        // sepolia
        11155111: {
            multisig: "0x337d8378848c3D7d07C0e56a59a912E2f091fE3C",
            proxyAdminAddress: "0x67Df244584b67E8C51B10aD610aAfFa9a402FdB6",
            treasury: "0xCF980ec23Ffe83a49F6b8d95f62361A42Da6A5C6",
            nftMarket: "0xa5ffFcf1C80435cCAe759891B6D122B4EFaFa810",
            percentSplit: "0x39AC88428232E753056e6E4155aC56B97DE5A2AC",
            feth: "0x734a19721feB90665F9C706110434BC86230aE39",
            middleware: "0x2278D6B29485E952c0763B4A5F209c12E77f51bF",
            nftCollectionFactoryV2: "0x53F451165Ba6fdbe39A134673d13948261B2334A",
            nftDropMarket: "0xFee588791CdA1D01CCFc80b51eFa00C0BE5B129e",
            nftMarketRouter: "0x9f410568EA56B4f083b9e244207727586aF454d2",
            worlds: "0x05C1BF785C56B81Ac8410347b6A729E8b030D00e",
            multiTokenDropMarket: "0x99961bEf4B551AE0c07612c8fa6Fedc43d2A7721",
            nftMarketExperiment: "0x2401d3B6dF096f31B3e32769837879d4D08fC21A",
            highlight: {
                mintManager: "0xd698911B1Bb2a9c849Bf5e2604aF110766f396b6",
                discreteDutchAuctionMechanic: "0xceBc3B3134FbEF95ED13AEcdF997D4371d022385",
            },
        },
        // base-sepolia
        84532: {
            multisig: "0xdbb23c52a60749040800f9709c3d462a0ff291a2",
            proxyAdminAddress: "0xcbBaD850692054F271b41367Bf78C345ddEa712B",
            treasury: "0xF2abB0b137Be074235BA71D477D7EF47C5F4BAe1",
            nftMarket: "0x2AE781421b8545576BA1Db916d9276C4FC76bB64",
            percentSplit: "0xB7468D32eE9b2CA97bCAE42d5a9e44CA671dD5B8",
            feth: "0xf8064DF28608D3871b4FC9c3943BDF1d21f1E1D3",
            middleware: "0x8dB9138a3e35f8aA905C419D96687E3A61d8BB05",
            nftCollectionFactoryV2: "0x0D0c39Ad9f93ea8e775Eaa1d2Fd410f5534dFaFE",
            nftDropMarket: "0xb35A843df9ec559fCDC59B5F5F48dFb989cbe114",
            nftMarketRouter: "0x0fc536D7F891e234EFF7050587935205ad167b2A",
            worlds: "0xfbb85CD4297E639a2e8c6ABAeeF2061298Fc1800",
            multiTokenDropMarket: "0xE750E597bFcDbe1C27322e729f1796B52DFCddDb",
            nftMarketExperiment: "0x8FC5A6E5Cd0B3C66659Da3303f7BfcC06aa1B073",
            highlight: {
                mintManager: "0x41cbab1028984A34C1338F437C726de791695AE8",
                discreteDutchAuctionMechanic: "0x4821B6e9aC0CCC590acCe2442bb6BB32388C1CB7",
            },
        },
    },
};
exports.addressesByChainId = {
    ...exports.addresses.prod,
    ...exports.addresses.staging,
};
//# sourceMappingURL=addresses.js.map